import { Page } from '@/core/architecture'

import { ConsoleOrderDetailTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleOrderDetail Page
 * Implemented as a practical sample.
 */
export const ConsoleOrderDetail: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleOrderDetailTemplate state={state} {...actions} />
}
